<mat-card [class.loading]="loading">
  <div class="content"><ng-content></ng-content></div>
  <mat-spinner diameter="32" *ngIf="loading"></mat-spinner>
</mat-card>
